import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="mt-8 bg-background-secondary border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-content-primary">About</h3>
            <p className="text-content-secondary">
              Animatronic Database is your ultimate resource for animatronics and animated figures worldwide.
            </p>
            <Link to="/about" className="text-brand hover:text-brand-light">
              Learn more about us →
            </Link>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-content-primary">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-content-secondary hover:text-brand">Home</Link></li>
              <li><Link to="/database" className="text-content-secondary hover:text-brand">Database</Link></li>
              <li><Link to="/map" className="text-content-secondary hover:text-brand">Database Map</Link></li>
              <li><Link to="/suppliers/directory" className="text-content-secondary hover:text-brand">Suppliers Directory</Link></li>
              <li><Link to="/ranking-game" className="text-content-secondary hover:text-brand">Ranking Game</Link></li>
              <li><Link to="/advertising" className="text-content-secondary hover:text-brand">Advertising</Link></li>
              <li><Link to="/contact" className="text-content-secondary hover:text-brand">Contact Us</Link></li>
            </ul>
          </div>

          {/* Legal & Contact */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-content-primary">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/legal/privacy" className="text-content-secondary hover:text-brand">Privacy Policy</Link></li>
              <li><Link to="/legal/terms" className="text-content-secondary hover:text-brand">Terms of Service</Link></li>
              <li><Link to="/legal/cookies" className="text-content-secondary hover:text-brand">Cookie Policy</Link></li>
              <li><Link to="/legal/disclaimer" className="text-content-secondary hover:text-brand">Disclaimer</Link></li>
              <li><Link to="/legal/copyright" className="text-content-secondary hover:text-brand">Copyright Policy</Link></li>
            </ul>

            <div className="pt-4">
              <h3 className="text-lg font-semibold text-content-primary">Connect</h3>
              <div className="flex items-center space-x-4 mt-2">
                <a 
                  href="https://linkedin.com/company/animatronic-database" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-content-secondary hover:text-brand"
                >
                  <Linkedin className="w-6 h-6" />
                </a>
                <a 
                  href="mailto:sales@animatronicdatabase.com"
                  className="text-content-secondary hover:text-brand"
                >
                  sales@animatronicdatabase.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer Section */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <p className="text-sm text-content-secondary mb-6 text-center mx-auto max-w-4xl">
            The content on Animatronic Database is for educational and informational purposes only. Images and videos are used under the assumption of fair use. If you believe your copyrighted content has been used without authorization, please contact us at{' '}
            <a href="mailto:legal@animatronicdatabase.com" className="text-brand hover:text-brand-light">
              legal@animatronicdatabase.com
            </a>
            {' '}to request removal. While we strive for accuracy, we cannot guarantee all content is error-free. Animatronic Database is not liable for any damages arising from site use.
          </p>

          <div className="flex flex-col items-center space-y-4">
            <p className="text-content-secondary text-center">
              © {new Date().getFullYear()} Big Leaf LLC. All rights reserved.
            </p>
            <button
              onClick={scrollToTop}
              className="p-2 bg-background rounded-lg text-content-secondary hover:text-brand transition-colors"
              aria-label="Back to top"
            >
              <ArrowUp className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;